// extracted by mini-css-extract-plugin
export default {"status":"QueueStatusCell-status-ssPVV TableRowCell-cell-giPrj","noMessages":"QueueStatusCell-noMessages-LHpKj"};